"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSeriesGeometriesSelector = void 0;
var create_selector_1 = require("../../../../state/create_selector");
var get_chart_theme_1 = require("../../../../state/selectors/get_chart_theme");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var utils_1 = require("../utils/utils");
var compute_series_domains_1 = require("./compute_series_domains");
var compute_small_multiple_scales_1 = require("./compute_small_multiple_scales");
var get_series_color_map_1 = require("./get_series_color_map");
var get_specs_1 = require("./get_specs");
var is_histogram_mode_enabled_1 = require("./is_histogram_mode_enabled");
exports.computeSeriesGeometriesSelector = create_selector_1.createCustomCachedSelector([
    get_settings_specs_1.getSettingsSpecSelector,
    get_specs_1.getSeriesSpecsSelector,
    compute_series_domains_1.computeSeriesDomainsSelector,
    get_series_color_map_1.getSeriesColorsSelector,
    get_chart_theme_1.getChartThemeSelector,
    get_specs_1.getAxisSpecsSelector,
    compute_small_multiple_scales_1.computeSmallMultipleScalesSelector,
    is_histogram_mode_enabled_1.isHistogramModeEnabledSelector,
], function (settingsSpec, seriesSpecs, seriesDomainsAndData, seriesColors, chartTheme, axesSpecs, smallMultiplesScales, isHistogramMode) {
    return utils_1.computeSeriesGeometries(seriesSpecs, seriesDomainsAndData, seriesColors, chartTheme, settingsSpec.rotation, axesSpecs, smallMultiplesScales, isHistogramMode);
});
//# sourceMappingURL=compute_series_geometries.js.map